import { useCompanyHasFunctionality } from "src/Pages/Company/CompanyContext";
import BenefitsPending from "./BenefitsMultiSportPending";
import PendingBenefitsWrapper from "./PendingBenefits";

const Pending = () => {
  const salaryDeductionEnabled = useCompanyHasFunctionality(
    "ENABLE_SALARY_DEDUCTION"
  );

  if (salaryDeductionEnabled) {
    return <PendingBenefitsWrapper />;
  }
  return <BenefitsPending />;
};

export default Pending;
